<template>
  <div id="not-found">
    <h1>您访问的地址有误</h1>
    <p>{{ msg }}</p>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
  data() {
    return {
      msg:'请检查您访问的地址'
    }
  },
  created() {
    this.msg = this.$route.query.msg||'请检查您访问的地址';
  },
  mounted() {

  }
}
</script>

<style scoped>
#not-found{
  color: #ffffff;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>
